import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { FileInput } from "@/components/FileInput";

export default function RequestVacationDialog({ open, onOpenChange, onSaved, initialFrom = "", initialTo = "" }) {
  const [form, setForm] = useState({ from_date: initialFrom, to_date: initialTo, type: "Vacaciones", reason: "" });
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const set = (k, val) => setForm((f) => ({ ...f, [k]: val }));
  const justifRequired = form.type === "Baja médica";

  const save = async () => {
    if (!form.from_date || !form.to_date) { toast.error("Indica las fechas de inicio y fin"); return; }
    if (justifRequired && !file) { toast.error("Adjunta el justificante (obligatorio para bajas médicas)"); return; }
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("from_date", form.from_date);
      fd.append("to_date", form.to_date);
      fd.append("type", form.type);
      fd.append("reason", form.reason || "");
      if (file) fd.append("file", file);
      await api.post("/hr/me/vacations", fd);
      toast.success("Solicitud enviada. Se ha avisado a la Directora.");
      onSaved && onSaved();
      onOpenChange(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error al solicitar");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Solicitar días</DialogTitle>
          <DialogDescription>Se descuentan solo los días laborables (excluye findes y festivos).</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1.5"><Label>Desde</Label><Input type="date" value={form.from_date} onChange={(e) => set("from_date", e.target.value)} data-testid="vac-from-input" /></div>
            <div className="space-y-1.5"><Label>Hasta</Label><Input type="date" value={form.to_date} onChange={(e) => set("to_date", e.target.value)} data-testid="vac-to-input" /></div>
          </div>
          <div className="space-y-1.5">
            <Label>Tipo</Label>
            <Select value={form.type} onValueChange={(val) => set("type", val)}>
              <SelectTrigger data-testid="vac-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="Vacaciones">Vacaciones</SelectItem>
                <SelectItem value="Asuntos propios">Asuntos propios</SelectItem>
                <SelectItem value="Baja médica">Baja médica</SelectItem>
                <SelectItem value="Otro">Otro</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5"><Label>Comentario / motivo (opcional)</Label><Textarea value={form.reason} onChange={(e) => set("reason", e.target.value)} className="resize-none" data-testid="vac-reason-input" placeholder="Añade un mensaje para quien lo apruebe" /></div>
          <div className="space-y-1.5">
            <Label>Justificante {justifRequired ? "(obligatorio)" : "(opcional)"}</Label>
            <FileInput file={file} onFile={setFile} accept="application/pdf,image/*,.doc,.docx" testid="vac-justif-input" />
            {justifRequired && <p className="text-xs text-gold">Para bajas médicas debes adjuntar el parte (PDF, imagen o Word, máx 10 MB).</p>}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={save} disabled={saving} data-testid="vac-submit-btn">{saving ? "Enviando…" : "Enviar solicitud"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
